import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { ConfigService } from '../../../services/config.service';
import { CustomerType } from '../../../models/client-configuration';

@Component({
  selector: 'app-iberia-landing',
  templateUrl: './iberia-landing.component.html',
  styleUrls: ['./iberia-landing.component.scss'],
})
export class IberiaLandingComponent {
  customerType: CustomerType;

  constructor(
    authService: AuthService,
    configService: ConfigService,
    private router: Router
  ) {
    const whitelistClientList = [
      'P0001', // test-developer
      'E0392', // iberia
    ];

    if (authService.isAuthenticated() || !whitelistClientList.includes(configService.get().codCliente)) {
      this.router.navigate(['/']);
      this.customerType = configService.customerType;
    }
  }

  onClick() {
    localStorage.setItem('landing', 'true');
    return this.router.navigate(['/']);
  }
}
